export default {"src":"/_next/static/media/0x80a16016cc4a2e6a2caca8a4a498b1699ff0f844.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};